import { resolveText } from "../../i18n/resolve-text.js";
import { startText, stopText } from "../../../i18n/text/airplay.js";
import { connectingText } from "../../../i18n/text/cast.js";
import { resolveLabel } from "../utils/resolve-label.js";
import { createState } from "@videojs/store";
import { supportsWebKitAirPlay } from "@videojs/utils/dom";
import { defaults } from "@videojs/utils/object";
//#region src/core/ui/airplay-button/core.ts
/** @internal */
var AirPlayButtonCore = class AirPlayButtonCore {
	static defaultProps = {
		label: "",
		disabled: false
	};
	state = createState({
		state: "disconnected",
		availability: "unsupported",
		disabled: true,
		hidden: true,
		label: ""
	});
	#props = { ...AirPlayButtonCore.defaultProps };
	#media = null;
	constructor(props) {
		if (props) this.setProps(props);
	}
	setProps(props) {
		this.#props = defaults(props, AirPlayButtonCore.defaultProps);
	}
	getLabel(state) {
		const label = resolveLabel(this.#props.label, state);
		if (label) return label;
		if (state.state === "connected") return stopText;
		if (state.state === "connecting") return connectingText;
		return startText;
	}
	getAttrs(state) {
		return {
			"aria-label": this.getLabel(state),
			"aria-disabled": state.disabled ? "true" : void 0,
			hidden: state.hidden ? "" : void 0
		};
	}
	setMedia(media) {
		this.#media = media;
	}
	getState() {
		const media = this.#media;
		const availability = supportsWebKitAirPlay() ? media.remotePlaybackAvailability : "unsupported";
		this.state.patch({
			state: media.remotePlaybackState,
			availability,
			disabled: this.#props.disabled || availability !== "available",
			hidden: availability !== "available"
		});
		this.state.patch({ label: resolveText(this.getLabel(this.state.current)) });
		return this.state.current;
	}
	async toggle(media) {
		this.setMedia(media);
		if (this.getState().disabled) return;
		try {
			await media.promptRemotePlayback();
		} catch {}
	}
};
//#endregion
export { AirPlayButtonCore };

//# sourceMappingURL=core.js.map